<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="营养套餐名称查找"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择企业"
            @change="changeEnterpriseSearch"
            style="width:180px"
          >
            <a-select-option value="">
              全部企业
            </a-select-option>
            <a-select-option
              v-for="item in enterpriseDropdownList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择就餐类型"
            @change="changeDinningTypeSearch"
            style="width:150px"
          >
            <a-select-option value="">
              全部就餐类型
            </a-select-option>
            <a-select-option value="1">早餐</a-select-option>
            <a-select-option value="2">午餐</a-select-option>
            <a-select-option value="3">晚餐</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="searchMenuList"
          >
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
    >
      <!-- 图片 -->
      <span slot="menuImg" slot-scope="data">
        <a-avatar
          :src="data ? data : 'images/noImg.jpg'"
          shape="square"
          style="border:1px solid #e8e8e8"
        />
      </span>
      <a slot="enterprise" slot-scope="data">{{ data }}</a>
      <!-- 单价 -->
      <a-tag slot="price" slot-scope="data">￥{{ data }}</a-tag>
      <template slot="dinnerType" slot-scope="data">
        <a-tag color="green" v-if="data === 1">早餐</a-tag>
        <a-tag color="cyan" v-else-if="data === 2">午餐</a-tag>
        <a-tag color="blue" v-else-if="data === 3">晚餐</a-tag>
        <span v-else>-</span>
      </template>
      <!-- 操作 -->
      <span slot="action" slot-scope="item">
        <a href="javascript:;" @click="detailItem(item)" v-show="item.hasDetail"
          >详情</a
        >
        <span v-show="!item.hasDetail">-</span>
      </span>
    </a-table>
    <!-- 详情弹窗 -->
    <dish-detail
      :showModal="detailModalShow"
      :modalLoading="detailModalLoading"
      :detailData="detailDataList"
      @cancel="detailModalHide"
    ></dish-detail>
  </div>
</template>

<script>
import dishDetail from './tpl/dish-detail'
import { getMenuList, GetMenuFoods } from '@/apis/nutritionDishes'
import { getEnterpriseDropdownList } from '@/apis/enterprise'

const columns = [{
  title: '菜品名称',
  dataIndex: 'name',
  align: 'center',
  key: 'name'
}, {
  title: '图片',
  dataIndex: 'menuImg',
  key: 'menuImg',
  align: 'center',
  scopedSlots: { customRender: 'menuImg' }
}, {
  title: '单价',
  dataIndex: 'price',
  key: 'price',
  align: 'center',
  scopedSlots: { customRender: 'price' }
}, {
  title: '发布企业',
  dataIndex: 'enterprise',
  key: 'enterprise',
  align: 'center',
  scopedSlots: { customRender: 'enterprise' }
}, {
  title: '就餐类型',
  dataIndex: 'dinnerType',
  key: 'dinnerType',
  align: 'center',
  scopedSlots: { customRender: 'dinnerType' }
}, {
  title: '描述',
  dataIndex: 'desc',
  key: 'desc',
  align: 'center'
}, {
  title: '食材及用量',
  key: 'action',
  align: 'center',
  scopedSlots: { customRender: 'action' }
}]

export default {
  data () {
    return {
      tableData: [],
      columns,
      search: {
        name: '',
        enterprise: '',
        type: ''
      },
      enterpriseDropdownList: [],
      tableLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getMenuList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this._getMenuList()
        }
      },
      // 右侧抽屉属性
      detailModalShow: false,
      detailModalLoading: false,
      detailDataList: []
    }
  },
  methods: {
    // 列表
    // 检索
    changeSearchText (e) {
      this.search.name = e.target.value
    },
    changeEnterpriseSearch (value) {
      this.search.enterprise = value
    },
    changeDinningTypeSearch (value) {
      this.search.type = value
    },
    searchMenuList () {
      this.pagination.current = 1
      this._getMenuList()
    },
    // 获取列表
    _getMenuList () {
      this.tableLoading = true
      getMenuList({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        name: this.search.name,
        companyId: this.search.enterprise,
        type: this.search.type
      }).then(res => {
        const result = res.data.attribute
        this.tableData = []
        this.pagination.total = result.count
        this.tableData = result.rows.map(item => ({
          key: item.id,
          id: item.id,
          name: item.name,
          menuImg: item.imgUrl,
          enterprise: item.companyName,
          price: item.defaultUnitPrice,
          dinnerType: item.menuType,
          desc: item.describe ? item.describe : '-',
          hasDetail: item.isFoodComponent
        }))
        this.tableLoading = false
      })
    },
    detailModalHide () {
      this.detailModalShow = false
    },
    detailItem (item) {
      this.detailModalShow = true
      this.detailModalLoading = true
      this.detailDataList = []
      GetMenuFoods({
        id: item.id
      }).then(res => {
        const result = res.data.attribute
        if (result.length) {
          this.detailDataList = result.map((item, index) => ({
            key: (index + 1).toString(),
            index: index + 1,
            foodName: item.foodName,
            foodNo: item.foodCode,
            foodWeight: item.weight + 'g'
          }))
        }
        this.detailModalLoading = false
      })
    },
    // 获取企业下拉
    _getEnterpriseDropdownList () {
      getEnterpriseDropdownList().then(res => {
        this.enterpriseDropdownList = res.data.attribute
      })
    }
  },
  mounted () {
    this._getMenuList()
    this._getEnterpriseDropdownList()
  },
  components: {
    dishDetail
  }
}
</script>
